/* global G */
import { curry } from 'lib/util'
import { settings } from 'app/_shared/session'
import format from 'lib/util/string'

/**
 * Opens the APM teaser PDF in a new tab.
 *
 * @param module    current module
 * @param component event source
 * @param event     triggered event
 */
const openPdf = (
  module: Gaia.AppModule.Spec,
  component: Gaia.Component.Spec,
  event: Gaia.PlatformEvent,
) => {
  const baseUrl = settings.apmTeaserUrl
  const currentLanguage = module[G.ADAPTER][G.SESSION][G.STATE][G.LANGUAGE]

  // We only have DE and EN PDFs, EN is always fallback
  const documentLanguage = (currentLanguage === 'de' ? currentLanguage : 'en').toUpperCase()
  const url = format(baseUrl, { lang: documentLanguage })

  module[G.ADAPTER][G.ROUTER].newTab({ url })
}

export default curry(openPdf)
